import { resetPasswordForAdmin } from '@/http/user/userApi'

export class AuthService {
  async changePasswordByAdmin(id) {
    await resetPasswordForAdmin(id)
  }
}
